/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowDebtorCollectionsQueryResponse, GetShowDebtorCollectionsPathParams, GetShowDebtorCollectionsQueryParams, GetShowDebtorCollections401, GetShowDebtorCollections403 } from "../../models/GetShowDebtorCollections";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowDebtorCollectionsUrl({ debtorCode }: { debtorCode: GetShowDebtorCollectionsPathParams["debtorCode"] }) {
  const res = { method: 'GET', url: `/api/v1/debtors/${debtorCode}/collections` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/collections}
 */
export async function getShowDebtorCollections({ debtorCode, params }: { debtorCode: GetShowDebtorCollectionsPathParams["debtorCode"]; params: GetShowDebtorCollectionsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowDebtorCollectionsQueryResponse, ResponseErrorConfig<GetShowDebtorCollections401 | GetShowDebtorCollections403>, unknown>({ method : "GET", url : getGetShowDebtorCollectionsUrl({ debtorCode }).url.toString(), params, ... requestConfig })  
  return res.data
}